import React from "react";
import ValidarSenha from "../../components/auth/ValidarSenha";
import { Voltar } from "../../components/Voltar";

export default function PrimeiroAcesso(props) {
	const handleSubmitSenha = (senha) => {
		props.handle({ email: props.email, password: senha, primeiroAcesso: true });
	}

	return (
		<div className="primeiro-acesso">
			<div className="voltar">

				<p className="titulo header-voltar">
					<Voltar onClick={() => props.setPage('LOGIN')} />	Primeiro acesso
				</p>
				<p className="subtitulo">Identificamos que esse é seu primeiro acesso. Crie uma senha para acessar sua conta.</p>

				<ValidarSenha handle={handleSubmitSenha} loading={props.loading}/>
			</div>
		</div>
	)
}